// extracted by mini-css-extract-plugin
module.exports = {"summary":"TransferSummary_summary__3-XL7"};